import React from "react";
import {
  Radio, Send, RefreshCw, Navigation, MapPin, FileText, AlertOctagon, XCircle, CheckCircle, Tool, Slash,
} from "react-feather";
import { formatDateTime } from "../alarmFormat";

// type -> how it reads in the timeline. The server derives most entries from the
// response's own columns, so every alarm has a complete history.
const META = {
  SIGNAL: { icon: Radio, color: "#C0392B", label: "Signal received" },
  DISPATCHED: { icon: Send, color: "#C0392B", label: "Dispatched" },
  REASSIGNED: { icon: RefreshCw, color: "#6C757D", label: "Unit changed" },
  OPENED: { icon: Navigation, color: "#B26A00", label: "Opened by unit" },
  ARRIVED: { icon: MapPin, color: "#0D6EFD", label: "Arrived on site" },
  REPORTED: { icon: FileText, color: "#6F42C1", label: "Reported back" },
  CAUSE_SET: { icon: AlertOctagon, color: "#C0392B", label: "Cause set" },
  CAUSE_CLEARED: { icon: Slash, color: "#6C757D", label: "Cause cleared" },
  CLOSED: { icon: CheckCircle, color: "#1E7B4A", label: "Closed" },
  PUSHED_TO_TECH: { icon: Tool, color: "#1E7B4A", label: "Pushed to Tech" },
  CANCELLED: { icon: XCircle, color: "#6C757D", label: "Cancelled" },
};

const AlarmTimeline = ({ activity }) => {
  if (!activity?.length) return <p className="text-muted small mb-0">No history yet.</p>;

  return (
    <div>
      {activity.map((a, idx) => {
        const meta = META[a.activityType] || { icon: FileText, color: "#6C757D", label: a.activityType };
        const Icon = meta.icon;
        const last = idx === activity.length - 1;
        return (
          <div key={`${a.activityType}-${idx}`} className="d-flex gap-3">
            <div className="d-flex flex-column align-items-center">
              <span
                className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                style={{ width: 28, height: 28, background: `${meta.color}1A`, color: meta.color }}
              >
                <Icon size={14} />
              </span>
              {!last && <span className="flex-grow-1" style={{ width: 2, background: "#E9ECEF", minHeight: 16 }} />}
            </div>
            <div className="pb-3" style={{ minWidth: 0 }}>
              <div className="fw-semibold" style={{ fontSize: 13.5 }}>
                {meta.label}
                {a.actedByName && <span className="text-muted fw-normal"> · {a.actedByName}</span>}
              </div>
              <div className="text-muted" style={{ fontSize: 12 }}>{formatDateTime(a.actedDate)}</div>
              {a.detail && <div style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{a.detail}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AlarmTimeline;
